/// Shop-specific scripts
function mobileLayout() {
  return $(window).width() < 768;
}

var lightbox_min_window_width = 768;
var lightbox_min_window_height = 580;

$('html').removeClass('no-js');

jQuery(function($){
  /// Sub-navs (aria-haspopup is for IE touchscreens)
  $('#pageheader .nav li:has(ul)').addClass('has-children').children('a').attr('aria-haspopup', 'true').siblings('ul').find('a').attr('aria-haspopup', 'false');
  
  /// Header images
  var $head_bg = $('#pageheader img.background');
  //If header exists... (remember switch from port->land on 7" tablet)
  if($head_bg.length > 0) {
    var fillModeIsCover = $('#pageheader .head-img-cont.fillmode-cover').length == 1;
    $('body').addClass('header-has-bg');
    if(fillModeIsCover) {
      $head_bg.willFillParent({ closest: '.head-img-cont', windowEvent: 'updateheaderimg debouncedresize' });
    }
    $head_bg.imagesLoaded(function(){
      
      $('<div class="background-shadow main"/><div class="background-shadow content-top"><div class="container"></div></div>')
      .css('opacity', 0).insertAfter($head_bg).animate({opacity:1}, 500);
      
      $head_bg.animate({opacity:1}, 500);
      $(window).trigger('updateheaderimg');
    });
    
    
    //Subtle parallax
    //Skip on tablets, for all manner of reasons
    var mobile = /iPad|iPhone|iPod|android|blackberry|mini|windows\sce|palm/i.test( navigator.userAgent );
    mobile || $(window).on('scroll scrollheaderbackground', function(){
      
      var h = $('#pageheader .head-img-cont').height();
      var scrollAmt = $(window).scrollTop();
      var fracScrolledPastImage = scrollAmt > h ? 1 : scrollAmt / h;
      var newOffsetTop = fracScrolledPastImage * h / 2; // Change '2' to adjust relative scroll
      
      if(fillModeIsCover) {
        $head_bg.css('margin-top', newOffsetTop);
      } else {
        $('#pageheader .head-img-cont').css('background-position', 'center ' + newOffsetTop + 'px');
      }
    }).trigger('scrollheaderbackground');
    
  }
  
  /// Galleries (only on large screens)
  if($(window).height() >= lightbox_min_window_height && $(window).width() >= lightbox_min_window_width) {
    $('a[rel="gallery"]').colorbox({rel:'gallery'});
  }
       
  /// Main nav
       
  //Double tap plugin courtesy of http://osvaldas.info/drop-down-navigation-responsive-and-touch-friendly
  //Handles showing dropdowns nicely on all devices. Only needed when not using mobile nav.
  if($('#pageheader .links-etc').css('position') != 'fixed') {
    $('#pageheader .nav > ul > li.has-children').doubleTapToGo();
  }
       
  //If expanding dropdown, make sure it's fully visible
  $('#pageheader').on('mouseenter', '.nav > ul > li.has-children', function(){
    var $dropdown = $(this).children('ul');
    $dropdown.toggleClass('anchor-right', $(this).offset().left + $dropdown.width() > $('#pageheader').width());
  });
  
  /// Mobile nav
  $(document).on('click', '.mobile-nav-toggle', function(e){
    e.preventDefault();
    $('body').toggleClass('reveal-mobile-nav');
  });
  $('<a href="#" class="mobile-nav-toggle" id="mobile-nav-return"></a>').appendTo('body');
  
  /// Button to scroll to the top (I've never really understood the point of these)
  $(window).on('scroll', function(){
    $('body').toggleClass('reveal-scroll-top', $(window).scrollTop() > 500);
  });
  $('#scroll-top').on('click', function(e){
    e.preventDefault();
    $('html:not(:animated),body:not(:animated)').animate({ scrollTop: 0}, 500 );
  });
  
  /// Modal search
  $(document).on('click', 'a[href="/search"], #search-modal', function(e){
    e.preventDefault();
    $('body').toggleClass('reveal-search-modal');
    if($('body').hasClass('reveal-search-modal')) {
      $('#search-modal input[name="q"]').focus();
    }
  }).on('click', '#search-modal form', function(e){
    e.stopPropagation(); // Don't trigger click on parents
  });
  
  /// Any slideshows?
  var defaultFlexsliderOpts = {
    controlNav: false,
    animation: 'fade', // 'slide' will also work
    slideshowSpeed: 7000 // delay between changing slides, default: 7000 (milliseconds)
  };
  $('.flexslider').flexslider(defaultFlexsliderOpts);
       
  /// Text that scales up/down based on container width
  var full_site_width = 1024;
  $(window).on('resizeScalingText debouncedresize', function(){
    $('.scaled-text').each(function(){
      var $base = $(this).closest('.scaled-text-base');
      var scale = $base.width() / (typeof $base.data('text-scale-from') != 'undefined' ? $base.data('text-scale-from') : full_site_width);
      $(this).css('font-size', (scale * 100) + '%');
  	});
  }).trigger('resizeScalingText');
       
  /// Gallery
  $('.product-photos').on('click', '.thumbnails .thumb', function(e){
    e.preventDefault();
    var $mainA = $(this).closest('.product-photos').find('.main a');
    //Show new image (if allowed)
    if($mainA.find('img').fadeToAnotherImage($(this).data('display-url'))) {
      $mainA.attr('href', $(this).attr('href'));
      $(this).addClass('active').siblings('.active').removeClass('active');
      //Var-img-link?
      
        
        
        
      
        var $opt = $('#product-select-option-0');
        if($opt.val() != $(this).attr('title')) {
          $opt.val($(this).attr('title')).trigger('change');
        }
      
    }
  }).on('click', '.load-all-thumbs', function(){
    //Expand all thumbs, removing gallery feature
    var $cont = $(this).closest('.product-photos').addClass('expanded-all');
    var $thumbs = $cont.find('.thumbnails');
    //Revert main image to first thumbnail
    $thumbs.find('.thumb:first').click();
    //Create new images
    $thumbs.find('.thumb:not(:first)').each(function(index){
      var $img = $('<img/>').attr({ src: $(this).data('display-url'), alt: $(this).attr('title') }).hide();
      var $row = $('<div class="main exp-image loading-img"/>').append( $('<a/>').attr({ href: $(this).attr('href'), title: $(this).attr('title') }).append($img) );
      $row.appendTo($cont).imagesLoaded(function(){
        $row.height($row.height());
        $img.css('opacity', 0).show().animate({opacity:1}, 2000);
        $row.animate({height: $img.height()}, 1000);
      });
    });
    $thumbs.remove();
    return false;
  }).on('click', '.main a', function(e){
    e.preventDefault();
    //Don't do anything if the screen isn't very tall
    if($(window).height() >= lightbox_min_window_height && $(window).width() >= lightbox_min_window_width) {
      //Create fake gallery
      $('#gallery-cont').remove();
      var $galleryCont = $('<div id="gallery-cont"/>').append( $(this).closest('.product-photos').find('a:has(img)').filter(function(){ return !($(this).parent().hasClass('thumbnails') && $(this).index() == 0) }).clone().attr({ rel: 'gallery', title: '' }) ).hide().appendTo('body');
      //Trigger box (on the right one)
      $galleryCont.children().colorbox().filter('[href="'+$(this).attr('href')+'"]').first().click();
    }
  });
       
  //Show a quick generic text popup above an element
  window.showQuickPopup = function(message, $origin){
    var $popup = $('<div class="simple-popup"/>');
    var offs = $origin.offset();
    $popup.html(message).css({ 'left':offs.left, 'top':offs.top }).hide();
    $('body').append($popup);
    $popup.css('margin-top', - $popup.outerHeight() - 10);
    $popup.fadeIn(200).delay(3500).fadeOut(400, function(){
      $(this).remove();
    });
  };
       
  //Ajax add-to-cart
  var shopifyAjaxAddURL = '/cart/add.js';
  var shopifyAjaxCartURL = '/cart.js';
  var shopifyAjaxStorePageURL = '/search';
    
  $(document).on('submit', 'form[action="/cart/add"]:not(.noAJAX)', function(e) {
    if(mobileLayout()) {
      return true;
    }
    var $form = $(this);
    //Disable add button
    $form.find(':submit').attr('disabled', 'disabled').each(function(){
      var contentFunc = $(this).is('button') ? 'html' : 'val';
      $(this).data('previous-value', $(this)[contentFunc]())[contentFunc]('Adding...');
    });
    
    //Add to cart
    $.post(shopifyAjaxAddURL, $form.serialize(), function(itemData) {
      //Enable add button
      $form.find(':submit').each(function(){
        $btn = $(this);
        var contentFunc = $(this).is('button') ? 'html' : 'val';
        //Set to 'DONE', alter button style, wait a few secs, revert to normal
        $btn[contentFunc]('Added to cart');
        setTimeout(function(){
          $btn.removeAttr('disabled')[contentFunc]($btn.data('previous-value'));
        }, 4000);
      });
      
      //Update header summary
      $.get(shopifyAjaxStorePageURL, function(data){
        var cartSummarySelector = '#pageheader .checkout-link';
        var $newCartObj = $($.parseHTML('<div>' + data + '</div>')).find(cartSummarySelector);
        var $currCart = $(cartSummarySelector);
        $currCart.replaceWith($newCartObj);
        //Show cart dropdown for a few seconds
        $newCartObj.addClass('reveal');
        setTimeout(function(){
          $newCartObj.removeClass('reveal');
        }, 4000);
      });
      
      
    }, 'text').error(function(data) {
      //Enable add button
      var $firstBtn = $form.find(':submit').removeAttr('disabled').each(function(){
        var contentFunc = $(this).is('button') ? 'html' : 'val';
        $(this)[contentFunc]($btn.data('previous-value'))
      }).first();
      
      //Not added, show message
      if(typeof(data) != 'undefined' && typeof(data.status) != 'undefined') {
        var jsonRes = $.parseJSON(data.responseText);
        window.showQuickPopup(jsonRes.description, $firstBtn);
      } else {
        //Some unknown error? Disable ajax and submit the old-fashioned way.
        $form.addClass('noAJAX');
        $form.submit();
      }
    });
    return false;
  });
       
  //General lightbox for all
  $('a[rel=lightbox]').colorbox();
       
  //Immmediately select contents when focussing on some inputs
  $(document).on('focusin click', 'input.select-on-focus', function(){
    $(this).select();
  }).on('mouseup', 'input.select-on-focus', function(e){
    e.preventDefault(); //Prevent mouseup killing select()
  });
       
  //Product blocks to have consistent heights, purely visual
  $(window).on('debouncedresize checkcaptionheights', function(){
    var productsPerRow = 4;
    var $caps = $('.prod-caption');    
    for(var i = 0; i < Math.ceil($caps.length / 4); i++) {
      var $toProcess = $caps.slice(i*4, (i+1)*4);
      var h = 0;
      $toProcess.each(function(){
        var ch = $(this).children().outerHeight();
        if(ch > h) h = ch;
      }).height(h);
    }
  }).trigger('checkcaptionheights');
});
